<template>
  <div id="box" class="login-container">
    <div class="login-box">
      <div class="left-panel">
        <div class="welcome-text">
          <div>Welcome!</div>
          <el-row :gutter="10">
            <el-col>
              <div style="width: 190px; height: 50px" id="xy"></div>
            </el-col>
          </el-row>
          <div style="font-size: 14px; color: #e9e9e9;">
             <div><b>测试账号：</b></div>
          <span><b>管理员：</b>admin</span>
          <span style="margin-left: 10px;"><b>密码：</b>12345</span>
          <br> 
          <span style="position: absolute;margin-left: -80px;"><b>用户：</b>user</span>
          <span style="position: absolute;margin-left: 14px;"><b>密码：</b>123</span>
          </div>
         
        </div>
      </div>
      <div id="viewY" class="right-panel">
        <el-form
          v-if="!showForgetPassword"
          :model="user"
          class="login-form"
          :rules="rules"
          ref="LoginRef"
          @keyup.enter.native="login"
        >
          <div class="form-header">
            <img src="@/assets/xylogo.png" alt="" class="logo" />
            超市管理系统
          </div>
          <el-form-item prop="username">
            <el-input
              prefix-icon="el-icon-user"
              size="medium"
              placeholder="请输入账号"
              v-model="user.username"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              prefix-icon="el-icon-lock"
              size="medium"
              show-password
              placeholder="请输入密码"
              v-model="user.password"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="login-button" @click="login">登 录</el-button>
          </el-form-item>
          <div class="form-footer">
            <div class="register-link">
              还没有账号？请<span @click="$router.push('/register')" class="link">注册</span>
            </div>
            <div class="forgot-password">
              <span @click="showResetPasswordPage" class="link">忘记密码</span>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div
      id="forgetPassword"
      v-if="showForgetPassword"
      class="forget-password-container"
    >
      <div class="form-header">找回密码:</div>
      <el-form :rules="rules" :model="user1" @submit.native.prevent @keyup.enter.native="resetPassword">
        <el-form-item prop="username">
          <el-input
            prefix-icon="el-icon-user"
            size="medium"
            v-model="user1.username"
            placeholder="请输入账号"
          ></el-input>
          <el-button type="primary" @click="resetPassword" class="reset-button">重置密码</el-button>
          <el-button type="default" @click="cancelReset" class="cancel-button">返回登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";

const option = {
  graphic: {
    elements: [
      {
        type: "text",
        left: "center",
        top: "center",
        style: {
          text: "心意超市管理系统",
          fontSize: 23 + "px",
          lineDash: [0, 50],
          lineDashOffset: 0,
          fill: "transparent",
          stroke: "white",
          lineWidth: 1,
        },
        keyframeAnimation: {
          duration: 3000,
          loop: true,
          keyframes: [
            {
              percent: 0.7,
              style: {
                fill: "transparent",
                lineDashOffset: 200,
                lineDash: [200, 0],
              },
            },
            {
              percent: 0.8,
              style: {
                fill: "transparent",
              },
            },
            {
              percent: 1,
              style: {
                fill: "white",
              },
            },
          ],
        },
      },
    ],
  },
};
import axios from "axios";
var youke = {
  code: 200,
  message: "游客",
  data: {
    id: 1,
    username: "游客",
    password: "游客",
    updateTime: null,
    token: "游客",
    role: "游客",
  },
  ok: true,
};
// localStorage.setItem("honey-user", JSON.stringify(youke)); //存储用户
export default {
  name: "Login",
  data() {
    return {
      code: "", //验证码组件传递过来的code
      found: false,
      user: {
        username: "",
        password: "",
      },
      user1: {
        username: "",
        password: "",
      },
      rules: {
        username: [{ required: true, message: "请输入账号", trigger: "blur" },
                   { max: 10, message: "账号长度不能超过10个字符", trigger: "blur" }
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      showForgetPassword: false,
      forgottenUsername: "",
    };
  },
  mounted() {
    let xyDom = document.getElementById("xy");
    let xyChart = echarts.init(xyDom);
    xyChart.setOption(option);
  },
  methods: {
    showResetPasswordPage() {
      this.user1.username = "";
      this.showForgetPassword = true;
    },
    resetPassword() {
      axios.get(this.$baseUrl+"/user/getByOnlyName").then((res) => {
        for (let key in res.data.data) {
          if (res.data.data[key].username == this.user1.username) {
            this.found = true;
            axios
              .put(
                this.$baseUrl+"/user/update/" + res.data.data[key].id,
                {
                  password: 123,
                }
              )
              .then((res) => {
                this.showForgetPassword = false;
                this.$message.success(
                  "你好!" + this.user1.username + "你的新密码为123,请登录"
                );
              })
              .catch((err) => {
                this.$message.error("系统错误");
              });
            return; // 找到匹配项后立即返回
          }
        }
        if (!this.found) {
          this.$message.error("请输入正确的账号");
        }
      });
    },
    cancelReset() {
      this.showForgetPassword = false; // 返回到最初的界面
    },
    getCode(code) {
      console.log(code);
      this.code = code;
    },
    login() {
      if (!this.user.username || !this.user.password) {
        this.$message.error("账号或密码不能为空");
        return; // 提前返回，不再执行下面的登录操作
      }
      //axios的post,自动把请求数据组装成json, 请求的Content-Type: application/json;charset=UTF-8
      axios
        .post(this.$baseUrl+"/user/login", {
          username: this.user.username,
          password: this.user.password,
        })
        .then((response) => {
          this.$message.success("登录成功");
          console.log(response);
          localStorage.setItem("honey-user", JSON.stringify(response.data)); //存储用户
          let user = JSON.parse(localStorage.getItem("honey-user") || "{}");
          this.$router.push("/manager");
          // if(user.data.role == "管理员"){
          //   this.$router.push("/manager");
          // }
          // if(user.data.role == "用户"){
          //   this.$router.push("/Normal");
          // }
        })
        .catch((response) => {
          this.$message.error("账号或密码错误");
          // this.$message.error(res.msg);
        });
    },
  },
};
</script>

<style scoped>
.login-container {
  height: 97.5vh;
  display: flex;
  align-items: center;
  background: linear-gradient(to right, lightblue, blue);
  justify-content: center;
}

.login-box {
  display: flex;
  background-color: white;
  backdrop-filter: blur(10px);
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  width: 50%;
  height: 500px;
  border-radius: 50px;
  overflow: hidden;
  flex-direction: row;
}

.left-panel {
  position: relative;
  flex: 1;
  text-align: center;
  font-size: 25px;
  color: white;
  background-color: #3441f7;
  box-shadow: 15px 0 15px rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.welcome-text {
  position: static;
  text-align: center;
}

.right-panel {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-form {
  width: 80%;
}

.form-header {
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
  position: relative;
}

.logo {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 23%;
  top: 32%;
  transform: translate(-50%, -50%);
}

.login-button {
  width: 100%;
}

.form-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.link {
  color: blue;
  cursor: pointer;
  font-weight: bold;
}

.forget-password-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  max-width: 400px;
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
}

.reset-button, .cancel-button {
  width: 100%;
  margin-top: 20px;
}

.el-button+ .el-button {
  margin-left: 0px;
}
@media (max-width: 768px) {
  .login-box {
    width: 90%;
    height: auto;
    flex-direction: column;
  }
  .logo {
     left: 23%;
     top: 35%;
  }
  .left-panel, .right-panel {
    flex: none;
    width: 100%;
  }

  .welcome-text {
    margin-top: 20px;
  }

  .forget-password-container {
    width: 90%;
  }
}
</style>
